import { useEffect } from "react";
import { useChatPanelStore } from "stores/chatPanel";
import { useChatContextStore } from "../providers/ChatContextProvider";

export const useRedirectWhenDiscussionGone = () => {
  const { discussion, discussionId, discussionIsPending } =
    useChatContextStore();
  const setPanelDiscussionId = useChatPanelStore(
    store => store.setPanelDiscussionId
  );

  useEffect(() => {
    if (!discussionId || discussionIsPending) return;
    if (!discussion) setPanelDiscussionId(null);
  }, [discussion, discussionId, discussionIsPending, setPanelDiscussionId]);
};
